import cn from 'classnames';
import { type FC } from 'react';

// styles
import dibsCss from 'dibs-css';
import styles from './PdpRespMarketplaceLoadingCarousel.scss';

export const PdpRespMarketplaceLoadingCarousel: FC = () => (
    <div className={cn(dibsCss.flex, dibsCss.flexCol, dibsCss.mbLarger)}>
        <span
            className={cn(
                dibsCss.mbMedium,
                dibsCss.hLarge,
                dibsCss.w300px,
                styles.animate,
                dibsCss.roundedSmall
            )}
        />
        <div className={cn(dibsCss.flex, dibsCss.justifyBetween, dibsCss.pxLarge)}>
            {[1, 1, 1, 1, 1].map((_, index) => (
                <div
                    key={index}
                    className={cn(
                        dibsCss.wFull,
                        dibsCss.h280px,
                        dibsCss.mxMedium,
                        styles.animate,
                        dibsCss.roundedSmall
                    )}
                />
            ))}
        </div>
    </div>
);
